import { jsxs, jsx } from 'react/jsx-runtime';
import { P1, Alert } from '@zooplus/ui-components';
import PaymentTab from '../PaymentTab/PaymentTab.js';
import PaymentTabsWrapper from '../PaymentTabsWrapper/PaymentTabsWrapper.js';
import img from '../../../assets/payconiq_logo.png.js';
import { useTranslation } from '../../../hooks/useTranslations.js';
import { usePaymentContext } from '../../../providers/PaymentContextProvider.js';
import { getPaymentMethodStatus } from '../../../utils/modernizePaymentUtils.js';
import styles from './Bancontact.module.scss.js';
import BancontactForm from './BancontactForm/BancontactForm.js';

const Bancontact = () => {
    const { t } = useTranslation();
    const { selectedPayment, setSelectedPayment, checkoutState } = usePaymentContext();
    const { paymentMethods, customerType } = checkoutState || {};
    const BC = paymentMethods?.find((pm) => pm.paymentMethodShortName === 'BC');
    const BM = paymentMethods?.find((pm) => pm.paymentMethodShortName === 'BM');
    return (jsxs("div", { "data-zta": "bancontact", children: [jsx(P1, { bold: true, children: t('checkout.payment.bancontact.method') }), jsxs(PaymentTabsWrapper, { className: styles.bancontactTabsWrapper, children: [BM && (jsx(PaymentTab, { paymentMethod: "BM", variant: getPaymentMethodStatus(BM, selectedPayment, customerType), onClick: () => setSelectedPayment(BM), url: img, title: t('general.payment.bancontact_mobile') })), BC && (jsx(PaymentTab, { paymentMethod: "BC", variant: getPaymentMethodStatus(BC, selectedPayment, customerType), onClick: () => setSelectedPayment(BC), title: t('general.payment.bancontact_card') }))] }), selectedPayment?.paymentMethodShortName === 'BC' ? (jsx(BancontactForm, {})) : (jsx(Alert, { "data-zta": "bm_text", children: "Legal text" }))] }));
};

export { Bancontact as default };
//# sourceMappingURL=Bancontact.js.map
